export interface BatchOrderAcceptLedgerRequest {
  rdoOutputType: string
  rdoBranchType: string
  branch: string
  rdoOutputConditionType: string
  traderType: string
  donorType: string
  acceptanceDateFrom: string
  acceptanceDateTo: string
  acceptanceType: string
  isAcceptanceSearchBooks: boolean
  isAcceptanceSearchAV: boolean
  isAcceptanceSearchMagazine: boolean
  collectionType: string
  collectionPeriod: boolean
  collectionNum1From: string
  collectionNum1To: string
  collectionNum2From: string
  collectionNum2To: string
  collectionNum3From: string
  collectionNum3To: string
  collectionNum4From: string
  collectionNum4To: string
  collectionNum5From: string
  collectionNum5To: string
  rdoOrderListOrder: string
  rdoSituationListOutput: string
  ndcDigits: string
  rdoAmountDispType: string
  isOutputAcceptanceDate: boolean
  shelfType: string
  rdoNdc: string
  ndc: string
  rdoAcceptLedgerOutputType: string
  acceptanceLedgerMemo: string
  batchType: string
}

export function BatchOrderAcceptLedgerRequestToJSON(
  value: BatchOrderAcceptLedgerRequest
): any {
  return {
    rdo_output_type: value.rdoOutputType,
    rdo_branch_type: value.rdoBranchType,
    branch: value.branch,
    trader_type: value.traderType,
    donor_type: value.donorType,
    rdo_output_condition_type: value.rdoOutputConditionType,
    acceptance_date_from: value.acceptanceDateFrom,
    acceptance_date_to: value.acceptanceDateTo,
    acceptance_type: value.acceptanceType,
    collection_type: value.collectionType,
    is_acceptance_search_books: value.isAcceptanceSearchBooks,
    is_acceptance_search_av: value.isAcceptanceSearchAV,
    is_acceptance_search_magazine: value.isAcceptanceSearchMagazine,
    collection_period: value.collectionPeriod,
    collection_num1_from: value.collectionNum1From,
    collection_num1_to: value.collectionNum1To,
    collection_num2_from: value.collectionNum2From,
    collection_num2_to: value.collectionNum2To,
    collection_num3_from: value.collectionNum3From,
    collection_num3_to: value.collectionNum3To,
    collection_num4_from: value.collectionNum4From,
    collection_num4_to: value.collectionNum4To,
    collection_num5_from: value.collectionNum5From,
    collection_num5_to: value.collectionNum5To,
    rdo_order_list_order: value.rdoOrderListOrder,
    rdo_situation_list_output: value.rdoSituationListOutput,
    ndc_digits: value.ndcDigits,
    rdo_amount_disp_type: value.rdoAmountDispType,
    is_output_acceptance_date: value.isOutputAcceptanceDate,
    shelf_type: value.shelfType,
    rdo_ndc: value.rdoNdc,
    ndc: value.ndc,
    rdo_accept_ledger_output_type: value.rdoAcceptLedgerOutputType,
    acceptance_ledger_memo: value.acceptanceLedgerMemo,
    batch_type: value.batchType
  }
}
